'use client';

import Link from 'next/link';
import { Trans, useTranslation } from 'react-i18next';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { Locale } from '@/seo/seo.types';

import * as S from './ExtraContent.styles';

const TERMS_AND_CONDITIONS: Record<Locale, string> = {
  az: 'https://boss.az/pages/terms-conditions',
  en: 'https://en.boss.az/pages/terms-conditions#_gl=1*chiam8*_ga*NTgwMTIxMjg3LjE3NTg4NzgwNjE.*_ga_68B6PJZXYD*czE3NjM0NTkyODYkbzMzJGcwJHQxNzYzNDU5Mjg2JGo2MCRsMCRoMA',
  ru: 'https://ru.boss.az/pages/terms-conditions#_gl=1*1u7vwdq*_ga*NTgwMTIxMjg3LjE3NTg4NzgwNjE.*_ga_68B6PJZXYD*czE3NjM0NTkyODYkbzMzJGcxJHQxNzYzNDU5NTEyJGo2MCRsMCRoMA'
};

export const PostingAgreement = () => {
  const { i18n } = useTranslation();
  const locale = i18n.language as Locale;

  return (
    <S.PostingAgreementWrapper>
      <Typography variant="body3">
        <Trans
          i18nKey="Common.terms_and_condition"
          components={{
            1: (
              <Typography
                variant="body3"
                as={Link}
                href={TERMS_AND_CONDITIONS?.[locale]}
                target="_blank"
              />
            )
          }}
        />
      </Typography>
    </S.PostingAgreementWrapper>
  );
};
